import {
  GET_MERCHANT_AGREEMENTS,
  GET_MERCHANT_AGREEMENTS_SUCCESS,
  MERCHANT_AGREEMENTS_API_ERROR,
} from "./actionTypes";

export const getMerchantAgreements = () => ({
  type: GET_MERCHANT_AGREEMENTS,
});

export const getMerchantAgreementsSuccess = merchantAgreements => ({
  type: GET_MERCHANT_AGREEMENTS_SUCCESS,
  payload: merchantAgreements,
});

export const merchantAgreementsApiError = error => ({
  type: MERCHANT_AGREEMENTS_API_ERROR,
  payload: error,
});
